import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useEffect } from "react";
import { fetchGetPointsMessage, fetchGetMessage } from "../../../../../../../api";
import { useState } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { fetchUnifiedProcessing } from "../../../../utils";

export default props =>{
    useStyles(cls);
    const { customer } = props;
    const [pointsData, setPointsData] = useState(null);
    const [message, setMessage] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(async () =>{
        let fetchData = await Promise.all([fetchGetPointsMessage(), fetchGetMessage("M1138")]);
        const [response1, response2] = fetchData;
        setPointsData(fetchUnifiedProcessing(response1));
        setMessage(fetchUnifiedProcessing(response2));
    }, []);

    return <div className={cls.PointsMessage}>
        <div className={cls.PointsHistory}>
            <Link to="/user/points-history/all"><FormattedMessage id="points_history" defaultMessage="Points History" /> {'>'}</Link>
        </div>
        
        <div className={cls.PointsNum}>
            <span className={cls.Num}>{pointsData?.points || 0}</span>
            <p className={cls.Amount}>
                <span>={pointsData?.exchangeAmount}</span>
            </p>
        </div>

        <div className={cls.ExpiringPoints}>
            <span className={cls.Font}>{pointsData?.overduePoints} <FormattedMessage id="points" defaultMessage="points" /> </span>
            <span><FormattedMessage id="expriring_soon" defaultMessage="Expriring Soon" /></span>
            <span className={cls.Question} onClick={()=>setShow(state=>!state)}>
                <span>?</span>
            </span>

            {
                message && show && <div className={cls.MessageTips}>
                    {message?.message}
                </div>
            }
        </div>
    </div>
}